import React, { useEffect, useState } from "react";
import styled from "styled-components";
import TaskCard from "../components/task/TaskCard";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCustomAlertStore,
  usePointStore,
  useProjectMEditStore,
  useTilesetStore,
} from "../Store/store";
import CreateBanner from "../components/common/CreateBanner";
import { getTaskList, getTileset } from "../api/ProjectAPI";

const Main = styled.main`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: auto;
  color: #fff;
  padding: 100px 50px 0px 50px;
  box-sizing: border-box;
  @media (max-width: 600px) {
    padding: 70px 20px 0px 20px;
  }
`;

const Header = styled.header`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  padding-bottom: 20px;
  margin-bottom: 20px;
  div {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  h1 {
    font-size: 24px;
    font-weight: 700;
    color: #fff;
  }
  p {
    color: rgba(255, 255, 255, 0.33);
    font-size: 15px;
  }
  select {
    width: 200px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background-color: transparent;
    color: #fff;
    padding: 0 10px;
  }
  select option {
    background-color: #1a1a1a;
    color: #fff;
  }
  @media (max-width: 600px) {
    flex-direction: column;

    h1 {
      font-size: 20px;
    }
    p {
      font-size: 13px;
    }
    select {
      width: 100%;
      height: 30px;
      padding: 5px;
    }
    select option {
      font-size: 12px;
    }
  }
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  padding-bottom: 40px;
  @media (max-width: 600px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

const EmptyState = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: rgba(255, 255, 255, 0.4);
  font-size: 18px;
  font-weight: 500;
  pointer-events: none;
  z-index: 0;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const CardContainerWrapper = styled.div`
  position: relative;
  min-height: 300px;
`;

export default function TaskListPage() {
  const [taskList, setTaskList] = useState([]);
  const { isTilesetLoaded, setIsTilesetLoaded, setTilesetUrl } =
    useTilesetStore();
  const { setFileId, setProjectId } = usePointStore();
  const { showInfoAlert } = useCustomAlertStore();
  const navigate = useNavigate();
  const { id } = useParams(); // 프로젝트 아이디
  const { isProjectMEditOpen } = useProjectMEditStore();
  const [accessType, setAccessType] = useState("COMPANY_INTERNAL");
  const onMapRendering = async (fileId) => {
    try {
      const response = await getTileset(fileId, "cesium");

      setFileId(fileId);
      setTilesetUrl(response.baseUrl);
      setIsTilesetLoaded(true);
      navigate("/");
    } catch (error) {
      if (error.response.status === 500) {
        showInfoAlert("타일셋 조회 실패", "파일이 아직 생성 중입니다.");
      }
    }
  };

  const onRouteGeneration = async (fileId, projectId) => {
    navigate(`/potree/${projectId}/${fileId}`);
  };

  const fetchTaskList = async (accessType) => {
    const response = await getTaskList(id, accessType);
    setTaskList(response);
    setProjectId(id);
  };

  // 태스크 목록 조회
  useEffect(() => {
    fetchTaskList(accessType);
  }, [isProjectMEditOpen, accessType]);

  return (
    <Main>
      <CreateBanner
        title="태스크 추가"
        description="태스크를 추가할 수 있습니다."
        link={`/task/create/${id}`}
      />
      <Header className="project-header">
        <div>
          <h1>프로젝트</h1>
          <p>관리중인 프로젝트를 확인할 수 있습니다.</p>
        </div>
        <select value={accessType} onChange={(e) => setAccessType(e.target.value)}>
          <option value="PUBLIC">전체 공개</option>
          <option value="COMPANY_INTERNAL">회사 내부 공개</option>
        </select>
      </Header>
      <CardContainerWrapper>
        {taskList.length === 0 && (
          <EmptyState>태스크가 없습니다</EmptyState>
        )}
        <CardContainer>
          {taskList.map((task, index) => (
            <TaskCard
              key={task.id}
              index={task.id}
              taskName={task.name}
              taskDescription={task.description}
              routeCount={task.waypointCount}
              date={task.createdAt}
              onMapRendering={onMapRendering}
              onRouteGeneration={onRouteGeneration}
              fileId={task.fileId}
              fetchTaskList={fetchTaskList}
              accessType={task.accessType}
              projectId={task.id}
              currentAccessType={accessType}
            />
          ))}
        </CardContainer>
      </CardContainerWrapper>
    </Main>
  );
}
